// components/PhoneInputField.js

import React, { useState } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import ErrorMessage from "./ErrorMessage";

const PhoneInputField = ({
  register,
  setValue,
  errors,
  validationMessage,
  regex,
  countryCode = "+91",
  placeholder,
  phone,
  setPhone,
  className,
  name,
  height = "43px",
  disabled = false,
  backgroundColor,
}) => {
  return (
    <div className="w-full">
      <PhoneInput
        enableSearch={true}
        // disableDropdown={true}
        // onlyCountries={["us"]}
        disabled={disabled}
        placeholder={placeholder || "Phone Number"}
        className={className}
        searchStyle={{
          alignItems: "center",
          width: "90%",
        }}
        country="in"
        value={phone}
        name={name}
        {...register(name, {
          required: validationMessage.MOBILE_NUMBER_REQUIRED,
        })}
        onChange={(value, data) => {
          setValue("countryCode", `+${data?.dialCode}`, {
            shouldValidate: true,
          });
          setValue(name, value?.slice(data?.dialCode?.length), {
            shouldValidate: true,
          });
          setPhone(data?.dialCode + value?.slice(data?.dialCode?.length));
        }}
        containerStyle={{
          height: height || "43px",
          outline: 0,
        }}
        dropdownStyle={{
          zIndex: 100,
          maxHeight: "100px",
          outline: 0,
        }}
        inputStyle={{
          width: "100%",
          height: height || "43px",
          outline: 0,
          paddingLeft: "62px",
          backgroundColor: backgroundColor || "",
        }}
      />
      {/* <ErrorMessage message={errors?.[name]?.message} /> */}
    </div>
  );
};

export default PhoneInputField;
